import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import AnimatedTopBar from './components/AnimatedTopBar';
import Header from './components/Header';
import Footer from './components/Footer';
import Cart from './components/Cart';
import ChatBot from './components/ChatBot';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import BlogPage from './pages/BlogPage';
import ScrollToTop from './components/ScrollToTop';

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage setCurrentPage={setCurrentPage} />;
      case 'catalog':
      case 'ppe':
      case 'tct':
      case 'enm':
      case 'mydTools':
      case 'ept':
      case 'heightWork':
      case 'isolatedTools':
      case 'manualandmotorTools':
        return <CatalogPage category={currentPage} />;
      case 'about':
        return <AboutPage />;
      case 'services':
      case 'maintenance':
      case 'laboratory':
      case 'consulting':
        return <ServicesPage service={currentPage} />;
      case 'contact':
        return <ContactPage />;
      case 'faq':
        return <FAQPage />;
      case 'blog':
        return <BlogPage />;
      default:
        return <HomePage setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <AppProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <AnimatedTopBar />
          <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
          
          <main className="flex-1">
            {renderCurrentPage()}
          </main>
          
          <Footer />
          <Cart />
          <ChatBot />
          <ScrollToTop trigger={currentPage} />
        </div>
      </Router>
    </AppProvider>
  );
};

export default App;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.